import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	alpha,
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		formPopupSessionTimeout_container: {
			display: 'flex',
			flexDirection: 'column',
		},
		formPopupSessionTimeout_body: {
			display: 'flex',
			flexDirection: 'row',
			color: theme.palette.info.main,
		},
		formPopupSessionTimeout_iconBody: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		formPopupSessionTimeout_iconWrapper: {
			borderRadius: '100%',
			padding: theme.spacing(2),
			background: alpha(theme.palette.secondary.main, 1),
			color: theme.palette.common.white,
			display: 'flex',
			flexDirection: 'column',
		},
		formPopupSessionTimeout_icon: {
			width: theme.spacing(6),
			height: theme.spacing(6),
		},
		formPopupSessionTimeout_text: {
			marginLeft: theme.spacing(3),
			lineHeight: theme.spacing(3),
		},
		formPopupSessionTimeout_btnRoot: {
			padding: '0px',
			backgroundColor: 'transparent',
			boxShadow: 'none',
			cursor: 'pointer',
			minWidth: 'unset',
			borderRadius: '0px',
			textDecoration: 'underline',
			color: theme.palette.info.main,
			whiteSpace: 'nowrap',
			justifyContent: 'flex-start',
			textTransform: 'none',
			fontSize: theme.typography.htmlFontSize,
			'&:hover': {
				backgroundColor: 'transparent',
				boxShadow: 'none',
			},
		},
	});
});

export default useStyles;
